import { game, poe1 } from '../../game';

export type LabelPreviewBackgroundId = 'bg1' | 'bg2' | 'bg3' | 'bg4';

export const LABEL_PREVIEW_BACKGROUNDS: { id: LabelPreviewBackgroundId; name: string }[] = [
  { id: 'bg1', name: poe1 ? 'Caves' : 'Woods' },
  { id: 'bg2', name: poe1 ? 'Road' : 'Desert' },
  { id: 'bg3', name: poe1 ? 'Desert' : 'Jungle' },
  { id: 'bg4', name: poe1 ? 'Indoor' : 'Caves' },
];

const LABEL_PREVIEW_BG_IDS = new Set<string>(LABEL_PREVIEW_BACKGROUNDS.map(b => b.id));

export function isLabelPreviewBackgroundId(id: string): id is LabelPreviewBackgroundId {
  return LABEL_PREVIEW_BG_IDS.has(id);
}

export function getLabelPreviewBgSmallUrl(id: string): string {
  return `/${game}-${id}.webp`;
}

export function getLabelPreviewBgLargeUrl(id: string): string {
  return `/${game}-${id}-large.webp`;
}

export function resolveLabelPreviewBgId(override: string | null, globalId: string): string {
  if (override !== null && isLabelPreviewBackgroundId(override)) {
    return override;
  }
  return isLabelPreviewBackgroundId(globalId) ? globalId : 'bg1';
}

export function labelPreviewBgImageStyle(id: string, large = false): string {
  const url = large ? getLabelPreviewBgLargeUrl(id) : getLabelPreviewBgSmallUrl(id);
  return `url('${url}')`;
}

export function labelPreviewBgThumbStyle(url: string): string {
  return `url('${url}')`;
}
